import { AnyAction } from "redux";

// Estado inicial
const initialState = {
  currentLanguage: "spanish", // Idioma por defecto
};

// Reducer de idioma
export default function languageReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case "SET_LANGUAGE":
      return {
        ...state,
        currentLanguage: action.payload, // Cambiar el idioma actual
      };
    default:
      return state; // Si no hay acción reconocida, devuelve el estado actual
  }
}
